import { SavedSearchesService } from "@tlc/ls2pac/components/pages/account/searches/SavedSearches";
import { TLCEventManager } from "../../../../js/lib/events/EventManager";
import { TLCLogger } from "../../../../js/lib/logger";
import { LS2PAC_CONSTANTS } from "../../../../js/main/constants";
import { ApplicationData } from "../ApplicationData";
import { SAVE_SEARCH_RESPONSE_EVENT, SAVE_SERCH_EVENT } from "../ClientManagers/DynamicListsClientManager";
import { ConfigListMiniPopupControl } from "./ConfigListMiniPopupControl";
import { SimpleErrorDialog } from "./simpleErrorDialog";
import { SuccessMessageControl } from "./successMessageControl";

export class SaveSearchControl extends ConfigListMiniPopupControl {
  constructor(initialSearchTerm) {
    var options = {
      id: LS2PAC_CONSTANTS.Ids.SearchPage.saveSearchPopUp,
      buttonId: LS2PAC_CONSTANTS.Ids.SearchPage.saveSearchButton,
      title: "",
      openEvent: LS2PAC_CONSTANTS.Events.onOpenSaveSearch,
      saveEvent: SAVE_SERCH_EVENT,
      saveResponseEvent: SAVE_SEARCH_RESPONSE_EVENT,
    };

    super(options, initialSearchTerm);

    var _this = this;
    $("#" + this.buttonId).on("click", function (event) {
      TLCLogger.log(escape(_this.currentSearchTerm));
      _this.openPopUp($(event.currentTarget));
      event.preventDefault();
    });
  }
  formSubmit() {
    var _this = this;
    this.getCurrentSearch(async function ({
      searchTerm: expression, 
      sortCriteria: sortType, 
      facetFilters, 
      branchFilters, 
      readingLevelFilters}) {

      try {
        const name = $("#" + _this.formId).find("input:text").val();
        const isConfig = $("#" + _this.isConfigId).is(":checked");
        const params = {
          name,
          expression,
          sortType,
          facetFilters,
          branchFilters,
          readingLevelFilters
        };
        const response = await SavedSearchesService.saveSearch(params, isConfig);
        SuccessMessageControl.show(
          ApplicationData.language.savedSearchSuccessMessage
        );
      }
      catch(e){
        console.error(e);
        SimpleErrorDialog.show(
          ApplicationData.language.savedSearchErrorMessage
        );
      }
    });
  }
  getCurrentSearch(callback) {
    TLCEventManager.addOneTimeListener(
      LS2PAC_CONSTANTS.Events.onGetCurrentSearchResponse,
      function (event) {
        callback(event.currentSearch);
      }
    );
    TLCEventManager.fireEvent(LS2PAC_CONSTANTS.Events.onGetCurrentSearch);
  }
  addEvents() {}
}
